import createReactComponent from '../createReactComponent';
export default createReactComponent('bed', 'IconBed', [
  ['path', { d: 'M3 7v11m0 -4h18m0 4v-8a2 2 0 0 0 -2 -2h-8v6', key: 'svg-0' }],
  ['path', { d: 'M7 10m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0', key: 'svg-1' }],
]);
